import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import * as yup from "yup";

export const AlterarSenhaSchema = yup.object().shape({
  senhaAntiga: yup.string().required(mensagemDeErroPadrao("Senha antiga")),

  novaSenha: yup
    .string()
    .required(mensagemDeErroPadrao("Nova senha"))
    .min(4, "Sua senha deve ter no mínimo 4 caracteres")
    .max(100, "Sua senha deve ter no máximo 100 caracteres")
    .oneOf([yup.ref("confirmarSenha")], 'O Campo "Repetir senha" e "Nova senha" devem ser iguais'),

  confirmarSenha: yup
    .string()
    .required(mensagemDeErroPadrao("Repetir senha"))
    .min(4, "Sua senha deve ter no mínimo 4 caracteres")
    .max(100, "Sua senha deve ter no máximo 100 caracteres")
    .oneOf([yup.ref("novaSenha")], 'O Campo "Nova senha" e "Repetir senha" devem ser iguais'),
});
